import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Transition as _Transition, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "employees__add"
}
const _hoisted_2 = { class: "employees__add-title" }
const _hoisted_3 = { class: "list-res-wrap" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "list-res" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "list-res-title" }
const _hoisted_8 = { class: "list-res-details" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "arrows__pagination"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 1,
  class: "list-res-empty"
}
const _hoisted_15 = {
  key: 2,
  class: "list-res-empty"
}

import VitaInput from '@/components/UI/VitaInput.vue';
import { ComponentPublicInstance, computed, nextTick, Ref, ref, watch } from 'vue';
import store from '@/store';
import { ExternalUser, NewUser } from '@/types';
import { checkUnsavedChanges, clearNull } from '@/utils/main';
import { reachGoal } from '@/utils/metrika';


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaEmployeeAdd',
  setup(__props) {

const userSearch = ref('')
const userSearchDrop = ref(false)
const inProcess = ref(false)
const currentPharmID = ref(0)
const searchDropRef: Ref<HTMLElement | ComponentPublicInstance | null> = ref(null)
const userSearchInput = ref<HTMLInputElement | null>(null)

const users = computed<NewUser[]>(() => {
  return store.getters["data/pharmUsers"];
});

// Есть ли у пользователя роль OFFLINE_DIRECTOR
const isOfflineDirectorRole = computed<boolean>(() => {
  return store.getters['getOfflineDirectorRole']
})

const searchUsersCount = computed(() => {
  return store.getters["data/newSearchUsersCount"];
});

const searchUsersList = computed<ExternalUser[]>(() => {
  return store.getters["data/newSearchUserList"];
});

const searchUsersListSkip = computed(() => {
  return store.getters["data/newSearchUsersSkip"];
});

const pharmId = computed(() => {
  return store.getters['data/pharmId']
});

// Есть ли у пользователя роль WFM_READER
const isWFMReaderRole = computed<boolean>(() => {
  return store.getters['getWFMReaderRole']
})

const hasArrows = computed(() => searchUsersCount.value > 5);
const noResults = computed(() => searchUsersList.value && searchUsersList.value.length === 0);
const hasPrevArrow = computed(() => searchUsersList.value.length > 0 && searchUsersListSkip.value > 0);
const hasNextArrow = computed(() =>
  searchUsersList.value.length > 0 && searchUsersCount.value > searchUsersListSkip.value + 5
);

const dropdownClasses = computed(() => ({
  'at-top': users.value.length < 3,
  'in-process': noResults.value ||
    (inProcess.value && !searchUsersList.value) ||
    (searchUsersList.value && searchUsersList.value.length < 2)
}));

const addNewUser = async (user: ExternalUser) => {
  userSearchDrop.value = false;

  // noinspection ES6RedundantAwait
  await store.commit('data/addUser', user);
  await store.dispatch("data/getTimeSchedule");

  checkUnsavedChanges()
  reachGoal('timetable-employee-add-selected')
}

const closeSearchDrop = () => {
  userSearchDrop.value = false
}

const openSearchDrop = (event: MouseEvent) => {
  if ((event.target === document.activeElement) && userSearchDrop.value) {
    return
  }

  if (currentPharmID.value === 0 || currentPharmID.value !== pharmId.value || searchUsersList.value?.length === 0) {
    searchUser();
  }

  userSearchDrop.value = true

  if (userSearch.value.length > 0) {
    userSearchDrop.value = true
  }
  reachGoal('timetable-employee-add-click')
}

const onSearchInput = () => {
  inProcess.value = true
  if (searchUsersListSkip.value > 0) {
    store.commit('data/setUserSearchSkip', 0)
  }
}

const searchUser = async () => {
  inProcess.value = true

  try {
    await store.dispatch('data/getPharmPeopleList', userSearch.value);
  } catch {
    if (localStorage.getItem('token')) console.error('Ошибка при поиске');
  } finally {
    inProcess.value = false
  }
}

const switchPage = async (direction: 'prev' | 'next') => {
  inProcess.value = true

  if (direction === 'next') {
    store.commit('data/increaseUserSearchQuery')
  } else {
    store.commit('data/decreaseUserSearchQuery')
  }
  await store.dispatch("data/getPharmPeopleList", userSearch.value);

  // Возвращаем scroll вверх при переключении страниц
  await nextTick(() => {
    const el = (searchDropRef.value as ComponentPublicInstance)?.$el || searchDropRef.value;
    if (el instanceof HTMLElement && el.scrollTop > 0) {
      el.scrollTop = 0;
    }
  });
  inProcess.value = false
}

const scrollOptions = { wheelPropagation: false, suppressScrollX: true }

const getFullName = (user: ExternalUser) => {
  const {lastName, firstName, middleName} = user
  return `${clearNull(lastName)} ${clearNull(firstName)} ${clearNull(middleName)}`;
}

// Задержка для запросов при вводе пользователя
let debounceTimer: ReturnType<typeof setTimeout>;

watch(userSearch, () => {
  if (debounceTimer) {
    clearTimeout(debounceTimer);
  }
  debounceTimer = setTimeout(() => {
    searchUser();
  }, 500);
});

return (_ctx: any,_cache: any) => {
  const _component_vita_icon = _resolveComponent("vita-icon")!
  const _component_perfect_scrollbar = _resolveComponent("perfect-scrollbar")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (pharmId.value && !isWFMReaderRole.value && !isOfflineDirectorRole.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_vita_icon, { name: "external-user" }),
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "Добавить сотрудника", -1))
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(VitaInput, {
            modelValue: userSearch.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userSearch).value = $event)),
            ref_key: "userSearchInput",
            ref: userSearchInput,
            type: "text",
            icon: "search",
            placeholder: "Сотрудник",
            oninput: onSearchInput,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openSearchDrop($event))),
            "data-qa": "employee-add-input-search"
          }, null, 8, ["modelValue"]),
          _createVNode(_Transition, { name: "fade-ease" }, {
            default: _withCtx(() => [
              (userSearchDrop.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["list-res-drop", dropdownClasses.value])
                  }, [
                    (searchUsersList.value && searchUsersList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_perfect_scrollbar, {
                            class: "list-res-scroll rail-thin",
                            options: scrollOptions,
                            ref_key: "searchDropRef",
                            ref: searchDropRef
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchUsersList.value, (user) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["list-res-item", {'disabled' : inProcess.value}]),
                                    key: user.zupGuid,
                                    onClick: ($event: any) => (addNewUser(user)),
                                    "data-qa": "employee-add-option-select"
                                  }, [
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(getFullName(user)), 1),
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", {
                                        title: user.position
                                      }, _toDisplayString(user.position) + " (" + _toDisplayString(user.bid) + ")", 9, _hoisted_9),
                                      (user.separator)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(user.separator), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 10, _hoisted_6))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }, 512),
                          (hasArrows.value && (hasPrevArrow.value || hasNextArrow.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("div", null, [
                                  (hasPrevArrow.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "arrows__pagination-item",
                                        type: "button",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (switchPage('prev'))),
                                        disabled: inProcess.value,
                                        "data-qa": "employee-add-button-page-prev"
                                      }, [
                                        _createVNode(_component_vita_icon, { name: "circle-arrow-left" })
                                      ], 8, _hoisted_12))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  (hasNextArrow.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "arrows__pagination-item",
                                        type: "button",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (switchPage('next'))),
                                        disabled: inProcess.value,
                                        "data-qa": "employee-add-button-page-next"
                                      }, [
                                        _createVNode(_component_vita_icon, { name: "circle-arrow-right" })
                                      ], 8, _hoisted_13))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : (inProcess.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Загрузка"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_15, "Результатов не найдено"))
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])), [
          [_directive_click_outside, () => closeSearchDrop()]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})